import React, { useEffect } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";
import VideoPlayer from "../components/VideoPlayer/VideoPlayer.js";

import { useNavigateWithVars } from "../hooks/useNavigateWithVars";
const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const navigateTo = useNavigateWithVars();

  if (game === null) return null;
  return (
    <div
      className={`Page Ablauf${props.className ? " " + props.className : ""}`}
    >
      <h1>{getLocalized("texts", "Spielablauf")}</h1>
      {/* <BlocksRenderer content={getLocalized("game", "Spielablauf")} /> */}
      {getLocalized("game", "Spielablauf") && (
        <div className="AufloesungBlock">
          <h3>{getLocalized("game", "Spielablauf")?.AudioHeadline}</h3>
          {getLocalized("game", "Spielablauf")?.Audio?.data && (
            <AudioPlayer
              url={
                process.env.REACT_APP_CMS_URL +
                getLocalized("game", "Spielablauf")?.Audio.data?.attributes?.url
              }
            ></AudioPlayer>
          )}
          <div>
            {getLocalized("game", "Spielablauf")?.AudioText && (
              <BlocksRenderer
                content={getLocalized("game", "Spielablauf")?.AudioText}
              />
            )}
          </div>
        </div>
      )}
      {props.children}
    </div>
  );
};

export default Page;
